import React from "react";

const ProfileIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="22"
      viewBox="0 0 19 22"
      fill="none"
    >
      <path
        d="M18.668 16.4824C18.499 13.1701 14.6187 10.5781 9.83711 10.5781C5.05556 10.5781 1.1815 13.1701 1.00626 16.4762V16.5008L1 17.9292C1 19.5853 2.37063 20.9336 4.05419 20.9336H15.6138C17.2973 20.9336 18.668 19.5853 18.668 17.9292V16.507C18.668 16.5008 18.668 16.4885 18.668 16.4824ZM15.62 20.0347H4.05419C2.87132 20.0347 1.91375 19.0928 1.91375 17.9292L1.92001 16.5131C1.99511 15.1895 2.8275 13.9397 4.26698 12.9977C5.76278 12.0188 7.74049 11.477 9.83711 11.477C11.9337 11.477 13.9114 12.0188 15.4072 12.9977C16.8467 13.9397 17.6791 15.1895 17.7542 16.5193V17.9292C17.7605 19.0866 16.7967 20.0347 15.62 20.0347Z"
        fill="#000"
        stroke="#000"
        stroke-width="0.5"
      />
      <path
        d="M9.76067 9.45737C12.164 9.45737 14.1229 7.53034 14.1229 5.16618C14.1229 2.80203 12.164 0.875 9.76067 0.875C7.35737 0.875 5.39844 2.80203 5.39844 5.16618C5.39844 7.53034 7.35111 9.45737 9.76067 9.45737ZM9.76067 1.77387C11.6633 1.77387 13.2091 3.29456 13.2091 5.16618C13.2091 7.03781 11.6633 8.5585 9.76067 8.5585C7.85806 8.5585 6.31219 7.03781 6.31219 5.16618C6.31219 3.29456 7.85806 1.77387 9.76067 1.77387Z"
        fill="#000"
        stroke="#000"
        stroke-width="0.5"
      />
    </svg>
  );
};

export default ProfileIcon;
